export default __webpack_public_path__ + "static/media/checked_new.0ff9cf1e.svg";